
  import Loader from "@/components/app/Loader.vue"
  import { computed, defineComponent, onBeforeMount, onMounted, provide } from "vue"
  import { useRoute, useRouter } from "vue-router"
  import { useStore } from "vuex"
  import { useI18n } from "vue-i18n"
  import "@/components/folders/scss/FolderPage.scss"

  export default defineComponent({
    name: "FolderPage",
    components: { Loader },
    setup() {
      const store = useStore()
      const router = useRouter()
      const route = useRoute()
      const folderItem = computed(() => store.getters.folder)
      const isLoader = computed(() => store.getters.isLoaderItem)
      const userID = computed(() => store.getters.userID)
      const currentWords = computed(() => store.getters.currentWords)

      const { t } = useI18n()
      provide("Ti18N", t)

      onBeforeMount(() => store.dispatch("getFolder", route.params.id))
      onMounted(() => store.dispatch("getWords"))

      const redirectWords = (title: string) => {
        const index = currentWords.value.findIndex((words: any) => words.title == title)
        if (index != -1) router.push(`/words/${userID.value}/${index}/?type=start`)
      }

      const deleteList = (title: string) => {
        store.dispatch("deleteWordsFromFolder", { title: title, folder: folderItem.value, key: route.params.id })
      }

      return {
        folderItem, isLoader, redirectWords, deleteList, t
      }
    },
  })
